import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Usef_person } from '../models/usef/usef_person';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class UsefPersonService {

	constructor(private http: HttpClient) { }

	getByUuid(uuid: string): Promise<Usef_person> {
		return this.getWithRest("uuid/" + uuid);
	}

	getByUsefId(usef_id: string, entity_type: string): Promise<Usef_person> {
		return this.getWithRest("usef_id/" + usef_id + "/entity_type/" + entity_type);
	}

	private getWithRest(rest_url: string) : Promise<Usef_person> {
	  	return new Promise((resolve, reject) => {

	  		return this.http.get(AppSettings.API_ENDPOINT + 'usef_people/' + rest_url).subscribe((response:any) => {
				if(response.type == 'usef_person' && response.data){
					resolve(response.data);
				} else {
					reject(response);
				}

			},
				error_response => {
		      		if(error_response instanceof HttpErrorResponse){
		      			reject(error_response.error);
		      		}
		      		reject(error_response);
				});


	  	});
	  }

}
